'use client';

import { useSpaceAutoSelector } from 'xstate/hooks/useSpaceAutoSelector';

// Tells the space machine which space, box and collection the URL points at,
// whenever the URL changes. It shows nothing on screen.
//
// It's a separate component so it can be placed inside
// PersistQueryClientProvider in providers.tsx. On a reload, the dashboard
// lists saved in localStorage are put back by that provider, and the check
// waits for them so the box can be shown straight from them. A component
// can only see that provider if it is placed inside it, which is why this
// isn't a plain hook call at the top of Providers.
const SpaceAutoSelector = (): null => {
  useSpaceAutoSelector();
  return null;
};

export default SpaceAutoSelector;
